import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import FlowBuilderAPI from '../../api/flowBuilder';

const TYPES = {
  SET_FLOWS: 'SET_FLOWS',
  ADD_FLOW: 'ADD_FLOW',
  EDIT_FLOW: 'EDIT_FLOW',
  DELETE_FLOW: 'DELETE_FLOW',
  SET_UI_FLAG: 'SET_UI_FLAG',
};

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getFlows: s => s.records,
  getUIFlags: s => s.uiFlags,
  getFlow: s => id => s.records.find(f => f.id === Number(id)),
};

const actions = {
  async get({ commit }) {
    commit(TYPES.SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await FlowBuilderAPI.get();
      commit(TYPES.SET_FLOWS, data.payload || []);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    commit(TYPES.SET_UI_FLAG, { isCreating: true });
    try {
      const { data } = await FlowBuilderAPI.create({ flow: payload });
      commit(TYPES.ADD_FLOW, data.payload);
      return data.payload;
    } finally {
      commit(TYPES.SET_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, ...payload }) {
    commit(TYPES.SET_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await FlowBuilderAPI.update(id, { flow: payload });
      commit(TYPES.EDIT_FLOW, data.payload);
      return data.payload;
    } finally {
      commit(TYPES.SET_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit(TYPES.SET_UI_FLAG, { isDeleting: true });
    try {
      await FlowBuilderAPI.delete(id);
      commit(TYPES.DELETE_FLOW, id);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isDeleting: false });
    }
  },

  async clone({ commit }, id) {
    commit(TYPES.SET_UI_FLAG, { isCreating: true });
    try {
      const { data } = await FlowBuilderAPI.clone(id);
      commit(TYPES.ADD_FLOW, data.payload);
      return data.payload;
    } finally {
      commit(TYPES.SET_UI_FLAG, { isCreating: false });
    }
  },

  async activate({ commit }, id) {
    const { data } = await FlowBuilderAPI.activate(id);
    if (data.payload) commit(TYPES.EDIT_FLOW, data.payload);
    return data.payload;
  },

  async deactivate({ commit }, id) {
    const { data } = await FlowBuilderAPI.deactivate(id);
    if (data.payload) commit(TYPES.EDIT_FLOW, data.payload);
    return data.payload;
  },
};

const mutations = {
  [TYPES.SET_UI_FLAG](s, data) {
    s.uiFlags = { ...s.uiFlags, ...data };
  },
  [TYPES.SET_FLOWS]: MutationHelpers.set,
  [TYPES.ADD_FLOW]: MutationHelpers.create,
  [TYPES.EDIT_FLOW]: MutationHelpers.update,
  [TYPES.DELETE_FLOW]: MutationHelpers.destroy,
};

export default { namespaced: true, state, getters, actions, mutations };
